/**
 * @desc 调拨单号解绑调拨批次号（未扫描、扫描中）
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationBatch.cancelScanAono.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/cancelScanAono`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
